import React, { useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING } from 'helper/constants';
import RadioList from 'components/RadioList';
import ForeignDemands from './components/ForeignDemands';
import LiveDemands from './components/LiveDemands';
import ForwardDemands from './components/ForwardDemands';
import DemandsInActive from './components/DemandsInActive';

const Demands = ({ handleViewDetail, productFilter = [], selectedProductName }) => {
  const [activeTab, setActiveTab] = useState(
    TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.LIVE,
  );
  const handleTabChange = (e) => setActiveTab(e.target.value);

  return (
    <>
      <RadioList
        LIST={TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING}
        activeTab={activeTab}
        handleTabChange={handleTabChange}
      />

      <TabContent activeTab={activeTab}>
        <TabPane tabId={TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.LIVE}>
          {activeTab === TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.LIVE && (
            <LiveDemands
              handleViewDetail={handleViewDetail}
              productFilter={productFilter}
              selectedProductName={selectedProductName}
            />
          )}
        </TabPane>
        <TabPane tabId={TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.FORWARD}>
          {activeTab === TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.FORWARD && (
            <ForwardDemands
              handleViewDetail={handleViewDetail}
              productFilter={productFilter}
              selectedProductName={selectedProductName}
            />
          )}
        </TabPane>
        <TabPane tabId={TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.FOREIGN}>
          {activeTab === TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.FOREIGN && (
            <ForeignDemands
              handleViewDetail={handleViewDetail}
              productFilter={productFilter}
              selectedProductName={selectedProductName}
            />
          )}
        </TabPane>
        <TabPane tabId={TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.INACTIVE}>
          {activeTab === TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.INACTIVE && (
            <DemandsInActive
              handleViewDetail={handleViewDetail}
              productFilter={productFilter}
              selectedProductName={selectedProductName}
            />
          )}
        </TabPane>
      </TabContent>
    </>
  );
};

export default Demands;
